import { httpAchievementDeptPersDel, httpAchievementDeptPersUpdateStatus, httpAchievementPersonalDeptPersionList, httpAchievementPersonalList, httpCompanyList, httpDeptFilter } from "@/services/customerServices";
import { message } from "antd";
import { MutableRefObject } from "react";

/**
 * 表格统一请求
 * @param values - 表单数据
 * @returns 
 */
export const fetchList = (values: any) => {
  return new Promise((resolve, reject) => {
    try {
      const { current, pageSize, query } = values;
      const data = {
        ...query,
        performanceCycleMonthId: query.yearMonth ? query.yearMonth.split('*')[1] : '',
      }
      httpAchievementPersonalList({current, pageSize, data}).then(resData => resolve(resData))
    } catch {
      reject({ success: false });
    }
  });
};

/** 获取门店列表 */
export const getCompanyFn = (compony: MutableRefObject<any>): Promise<any> => {
  return new Promise(async (resolve) => {
    const companyList: any = await httpCompanyList()
    const companyTree: any[] = [{ title: '全部门店', val: [], key: '0-0', child: [] }];
    if (companyList.length) {
      for (let i = 0; i < companyList.length; i++) {
        companyList[i].title = companyList[i].name;
        companyList[i].val = companyList[i].code + '';
        companyList[i].key = companyList[i].val;
        companyList[i].id = companyList[i].id + '';
        companyTree[0].val.push(companyList[i].val);
        companyTree[0].child.push(companyList[i]);
      }
    }
    compony.current = companyTree
    resolve(companyTree[0].child);
  });
};

export const getProductionType = () => {
  return new Promise(async (resolve) => {
    resolve({
      DRAFT: '草稿',
      PENDING: '待审批',
      REJECT: '审核不通过',
      CONFIRM: '已确认',
    });
  });
};

/**
 * 获取部门数据集合
 * @param deptCode - 登录账号部门Code
 * @returns 
 */
export const getDept = async (deptCode?: string | number) => {
  if (deptCode) {
    const resData: any = await httpDeptFilter(
      {
        companyCodes: deptCode,
        functionCodes: ['marketing', 'design', 'YLmarketing', 'YLsoftDecoration', 'team']
      })
    return resData
  } else {
    message.warning('未设置部门信息');
  }
};

/**
 * 获取部门人员数据集合
 * @param userInfo - 用户登录信息
 * @param dept - 部门Ref
 * @returns 
 */
export const getPernonal = (deptCode: any, dept: MutableRefObject<any>) => {
  if (deptCode) {
    return new Promise(async (resolve) => {
      httpAchievementPersonalDeptPersionList({
        deptPositionRequest: {
          deptCodes: [deptCode]
        }
      }).then((response: any) => {
        console.log('response', response);
        dept.current = response;
        resolve(response);
      })
    });
  } else {
    message.warning('未设置部门信息');
  }
};

/**
 * 变更部门信息
 * @param value 
 * @param status 
 * @param listRef 
 */
export const changeStatusFn = (value: any, status: string, listRef: MutableRefObject<any>) => {
  httpAchievementDeptPersUpdateStatus({
    id: value.id,
    status: status,
  }).then(() => {
    listRef.current?.reload();
  });
};

/**
 * 删除部门信息
 * @param value 
 * @param listRef 
 */
export const delFn = (value: any, listRef: MutableRefObject<any>) => {
  httpAchievementDeptPersDel(value.id).then(() => {
    listRef.current.reload();
  });
};